import { render, staticRenderFns } from "./AreaSelectView.vue?vue&type=template&id=70aa60ff"
import script from "./AreaSelectView.vue?vue&type=script&lang=js"
export * from "./AreaSelectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports